<template>
  <div
    class="tasks-view-toolbar-shell d-flex align-center justify-space-between flex-wrap"
    data-testid="tasklist__toolbar"
  >
    <div class="tasks-view-toolbar-shell__chrome" data-testid="tasklist__toolbar-tabs-group">
      <RoleSwitcher
        :value="userType"
        :show-manager="showManagerRole"
        @change="$emit('role-change', $event)"
      />
      <div
        v-if="horizonViewEnabled"
        class="tasks-view-toolbar-shell__divider"
        aria-hidden="true"
      />
      <v-btn-toggle
        v-if="horizonViewEnabled"
        :value="viewMode"
        mandatory
        class="view-mode-toggle"
        dense
        data-testid="tasklist__view-mode-toggle"
        @change="$emit('view-mode-change', $event)"
      >
        <v-btn
          :value="false"
          dense
          class="view-mode-toggle__btn"
          :class="{ 'view-mode-toggle__btn--active': viewMode === false }"
          data-testid="tasklist__list-view-btn"
        >
          <v-icon :class="{ 'mr-1': viewMode === false }">mdi-format-list-bulleted</v-icon>
          <span v-if="viewMode === false" class="view-mode-toggle__label">List</span>
        </v-btn>
        <v-btn
          :value="true"
          dense
          class="view-mode-toggle__btn"
          :class="{ 'view-mode-toggle__btn--active': viewMode === true }"
          data-testid="tasklist__horizon-view-btn"
        >
          <img src="/img/icons/fbc-icons/CalendarFilter.svg" alt="Horizon View" class="view-mode-toggle__icon">
          <span v-if="viewMode === true" class="view-mode-toggle__label">Horizon</span>
        </v-btn>
      </v-btn-toggle>
    </div>

    <div class="tasks-view-toolbar-shell__content">
      <slot />
    </div>
  </div>
</template>

<script>
import './TasksViewToolbarShell.scss';
import RoleSwitcher from '../../../../../components/RoleSwitcher/RoleSwitcher.vue';

export default {
  name: 'TasksViewToolbarShell',
  components: {
    RoleSwitcher,
  },
  props: {
    userType: {
      type: String,
      default: 'manager',
    },
    showManagerRole: {
      type: Boolean,
      default: true,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    horizonViewEnabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
